import createAddAction from '../lib/create_add_action';
import createTakenError from 'scripts/domain/factories/error/create_taken_error';
import RoutingGroup from 'models/routing_group';
import DtoConverter from 'scripts/application/dto_converters/routing_group_converter';

export default class CreateRoutingGroup extends createAddAction(RoutingGroup, { asDto: DtoConverter.toDto }) {
  _getValidationErrors(attrs) {
    var modelErrors = RoutingGroup.getValidationErrors(attrs);

    var namingConflict = !!this.context.stores.routingGroups.findAll({ name: attrs.name }).length;

    var namingErrors = namingConflict ? [createTakenError('name', attrs.name)] : [];

    return modelErrors.concat(namingErrors);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/routing_groups/create_routing_group.js